module.exports = __webpack_public_path__ + "img/form_ape.a0a37c26.jpeg";